import type { LegacyControlProgramTagCategory } from "api/legacy/model/legacyControlProgramTagCategory";
import type { LegacyDataSheetGrouping } from "api/legacy/model/legacyDataSheetGrouping";
import type { LegacyUser } from "api/legacy/model/legacyUser";

const CONTROL_TESTED_STATUS = 460;

/** The Rust backend answers 460 when a delete is blocked by tested controls. */
export function isControlTestedError(error: unknown): boolean {
    const status = (
        error as { response?: { status?: number } } | null | undefined
    )?.response?.status;
    return status === CONTROL_TESTED_STATUS;
}

export function formatLegacyUserName(user: LegacyUser | undefined): string {
    if (!user) {
        return "";
    }
    return [user.Firstname, user.Lastname].filter(Boolean).join(" ");
}

interface TagWithCategory {
    id: string;
    category: string;
    name: string;
}

export function getTags(
    tagIds: string[],
    tagCategories: LegacyControlProgramTagCategory[]
): TagWithCategory[] {
    const tagIdToTag = new Map<string, TagWithCategory>();
    for (const category of tagCategories) {
        for (const tag of category.Tags) {
            if (tag.Id) {
                tagIdToTag.set(tag.Id, {
                    id: tag.Id,
                    category: category.Name,
                    name: tag.Name,
                });
            }
        }
    }
    return tagIds
        .map((tagId) => tagIdToTag.get(tagId))
        .filter((tag): tag is TagWithCategory => tag !== undefined)
        .sort(
            (a, b) =>
                a.category.localeCompare(b.category) ||
                a.name.localeCompare(b.name)
        );
}

export function affectedControlTitles(
    groupings: LegacyDataSheetGrouping[]
): string[] {
    const titles = groupings.flatMap((grouping) =>
        grouping.AssignedInTasks.map((task) => task.ControlTitle)
    );
    return [...new Set(titles)];
}
